/**
 * Load recaptcha script
 * @returns {Promise<void>}
 */
async function loadRecaptcha() {
    const CAPTCHA_LOAD_TIMEOUT = 5000;

    return new Promise((res, rej) => {
        // can't wait forever
        const timeoutId = setTimeout(() => rej(new Error("Recaptcha timed out")), CAPTCHA_LOAD_TIMEOUT);

        grecaptcha.enterprise.ready(() => {
            clearTimeout(timeoutId);
            res();
        });
    });
}


/**
 * Get recaptcha token to formValues
 * @param {string} action action to validate
 * @returns {Promise<string>} token
 */
export async function getCaptchaToken({ action }) {
    await loadRecaptcha();

    const key = document.getElementById("antifraud-recaptcha").getAttribute("data-key");

    return grecaptcha.enterprise.execute(key, { action });
}

